<template>
  <div>
    <v-row
      v-for="index in numberOfSkeletons"
      class="mb-8 flex-nowrap w-100"
      no-gutters
      :key="index"
      :class="{ 'flex-row-reverse': index % 2 === 0 }"
    >
      <v-skeleton-loader class="avatar" type="avatar" />
      <v-skeleton-loader
        class="message-box w-40 pa-3 rounded-lg mx-2"
        min-width="250"
        type="card-heading, list-item-three-line"
      />
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'message-skeleton',
  props: {
    numberOfSkeletons: {
      type: Number,
      default: 1
    }
  }
};
</script>
<style scoped>
.message-box {
  background-color: #eee;
}

.v-skeleton-loader >>> .v-skeleton-loader__avatar {
  width: 25px;
  height: 25px;
  margin: 0;
}

.v-skeleton-loader >>> .v-skeleton-loader__card-heading,
.v-skeleton-loader >>> .v-skeleton-loader__list-item-three-line {
  background-color: #eee;
}

.v-skeleton-loader >>> .v-skeleton-loader__heading {
  margin: 0;
  height: 16px;
  width: 32%;
}

.v-skeleton-loader >>> .v-skeleton-loader__list-item-three-line {
  height: unset;
  padding: 0;
  margin-top: 16px;
}
</style>
